import styled from 'styled-components';
import PropTypes from 'prop-types';
import BaseBox from '@tds/core-box';

const Row = styled(BaseBox)`
  width: ${props => props.width}%;
  display: flex;
  justify-content: ${props => props.justifyContent};
  flex-direction: row;
  flex-wrap: wrap;
  padding: 16px;
  @media screen and (max-width: 992px) {
    display: block;
    width: ${props => props.mdWidth}%;
    padding: 16px 0;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: start;
  input {
    width: 100%;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    font-size: 1rem;
    letter-spacing: -0.8px;
    line-height: 1.5;
    font-weight: 400;
    color: rgb(42, 44, 46);
    min-height: 3rem;
    max-height: 3rem;
    margin: 0px;
    outline: 0px;
    border-color: rgb(84, 89, 95);
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    :focus {
      box-shadow: rgb(84, 89, 95) 0px 0px 4px 1px;
      background-color: rgb(255, 255, 255);
      border-color: transparent;
    }
  }
  div.react-datepicker-wrapper {
    width: 100%;
  }
`;

export const DateWrapper = styled(BaseBox)`
  margin-right: ${props => props.mr}px;
  width: ${props => props.width};
  position: ${props => props.position};
  @media screen and (max-width: 992px) {
    width: 100%;
    margin: 8px 0;
  }
  input {
    background: none;
  }
`;

export const ButtonWrapper = styled.div`
  fieldset > div {
    flex-flow: row nowrap;
  }
`;

export const FilterGridContainer = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(8, 100px);
  grid-template-areas:
    'f-product'
    'f-status'
    'f-salesRep'
    'f-province'
    'f-channel'
    'f-dates'
    'f-actionButtons';

  @media screen and (min-width: 961px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(5, 100px);
    grid-template-areas:
      'f-product f-status'
      'f-salesRep'
      'f-province f-channel '
      'f-dates .'
      'f-actionButtons .';
  }

  @media screen and (min-width: 1281px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 100px);
    grid-template-areas:
      'f-product f-status f-salesRep'
      'f-province f-channel'
      'f-dates . .'
      '. . .'
      'f-actionButtons . .';
  }
`;

Row.propTypes = {
  justifyContent: PropTypes.string,
  width: PropTypes.number,
  mdWidth: PropTypes.number
};

Row.defaultProps = {
  justifyContent: 'space-between',
  width: 100,
  mdWidth: 100
};

export { Row, InputWrapper };
